import { render, staticRenderFns } from "./CustomerInvoicesView.vue?vue&type=template&id=3a922952&"
import script from "./CustomerInvoicesView.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoicesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports